// Firestore serve solo quando l'utente condivide: si carica a quel momento,
// cosi' le pagine che importano questo modulo non pagano i 350 KB dell'SDK.
async function caricaFirestore() {
  const [firestore, { firebaseInit }] = await Promise.all([import('firebase/firestore'), import('/js/firebaseInit.js')]);
  return { ...firestore, firebaseInit };
}

const CHARSET = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';
// Referral UTM policy (requested):
// - utm_source=referral
// - utm_medium=referral
// - utm_campaign=sharing_link
const DEFAULT_SOURCE = 'referral';
const DEFAULT_MEDIUM = 'referral';
const DEFAULT_CAMPAIGN = 'sharing_link';

function generateShortCode(length = 6) {
  let code = '';
  for (let i = 0; i < length; i += 1) {
    code += CHARSET.charAt(Math.floor(Math.random() * CHARSET.length));
  }
  return code;
}

export function appendShareTrackingParams(originalUrl, campaign = DEFAULT_CAMPAIGN) {
  try {
    const url = new URL(originalUrl, window.location.origin);
    // Force consistent referral UTMs (overwrite any existing UTMs)
    url.searchParams.set('utm_source', DEFAULT_SOURCE);
    url.searchParams.set('utm_medium', DEFAULT_MEDIUM);
    url.searchParams.set('utm_campaign', campaign || DEFAULT_CAMPAIGN);
    return url.toString();
  } catch (error) {
    console.error('appendShareTrackingParams failed', error);
    return originalUrl;
  }
}

async function getUniqueShortCode(shortUrlsRef, { doc, getDoc }) {
  const maxAttempts = 5;
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const shortCode = generateShortCode(6 + Math.floor(Math.random() * 3));
    const docRef = doc(shortUrlsRef, shortCode);
    const existing = await getDoc(docRef);
    if (!existing.exists()) {
      return { shortCode, docRef };
    }
  }
  throw new Error('Unable to generate unique short code');
}

export async function createShortUrl(originalUrl, campaign = DEFAULT_CAMPAIGN) {
  const trackedUrl = appendShareTrackingParams(originalUrl, campaign);
  const firestore = await caricaFirestore();
  const { getFirestore, collection, setDoc, serverTimestamp, firebaseInit } = firestore;
  const { app } = firebaseInit();
  const db = getFirestore(app);
  const shortUrlsRef = collection(db, 'shortUrls');
  const { shortCode, docRef } = await getUniqueShortCode(shortUrlsRef, firestore);

  const payload = {
    originalUrl: trackedUrl,
    shortCode,
    baseUrl: window.location.origin,
    createdAt: serverTimestamp(),
    utm_source: DEFAULT_SOURCE,
    utm_medium: DEFAULT_MEDIUM,
    utm_campaign: campaign || DEFAULT_CAMPAIGN
  };

  await setDoc(docRef, payload);

  const base = window.location.origin || 'https://www.stipendee.it';
  return `${base}/s/${shortCode}`;
}
